















import Vue from 'vue';
import Icon from '../../../basic/Icon.vue';

export default Vue.extend({
  name: 'HeaderCell',
  props: {
    field: {
      type: String,
      required: true,
    },
    sortable: {
      type: Boolean,
    },
  },
  components: {
    Icon,
  },
  computed: {
    isSorted() {
      // @ts-ignore: $parent is Header which has sortField prop
      return this.$parent.sortField === this.field;
    },
    isSortedAsc() {
      // @ts-ignore: $parent is Header which has sortAsc prop
      return this.$parent.sortAsc;
    },
  },
  created() {
    // This component is tighlty coupled with a Header
    // Check for valid parent
    // @ts-ignore: $parent is a component
    if (!this.$parent || this.$parent.$options.name !== 'Header') {
      throw new Error('HeaderCell must be a child of Header');
    }
  },
});
